import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "betabadge badge bg-dark m-2" }, "BETA", -1)

import MobileWarning from '@/components/MobileWarning.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    _hoisted_2,
    _createVNode(MobileWarning)
  ]))
}
}

})